import { render, staticRenderFns } from "./InviteRecall.vue?vue&type=template&id=222798d4&scoped=true&"
import script from "./InviteRecall.vue?vue&type=script&lang=js&"
export * from "./InviteRecall.vue?vue&type=script&lang=js&"
import style0 from "./InviteRecall.vue?vue&type=style&index=0&id=222798d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222798d4",
  null
  
)

export default component.exports